import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CoreModule } from './core/core.module';
import { SharedModule } from '@app/shared';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent, AppRootComponent } from './app.component';
import { PageNotFoundComponent } from './modules/authentication/page-not-found/page-not-found.component';
import { LoginComponent } from './modules/authentication/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgZorroAntdModule, NZ_I18N, en_US } from 'ng-zorro-antd';

/** config angular i18n **/
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { ViewComponent } from './modules/view/view.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ResetPasswordComponent } from './modules/authentication/reset-password/reset-password.component';
registerLocaleData(en);

@NgModule({
  declarations: [AppRootComponent, AppComponent, PageNotFoundComponent, LoginComponent, ViewComponent, ResetPasswordComponent],
  imports: [
    // angular
    BrowserModule,
    // core & shared
    CoreModule,
    SharedModule,
    // app
    
    AppRoutingModule,
    // features
    BrowserAnimationsModule,
    FormsModule,
    NgZorroAntdModule,NgxCaptchaModule
  ],
  providers: [{ provide: NZ_I18N, useValue: en_US }],
  bootstrap: [AppRootComponent]
})
export class AppModule { 

  

}
